/**
 * Apple Ads：广告命名模板 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 镜像 services/huawei/adNameTemplate.ts；差异：Apple Ads 一页两组模板
 * （campaign=广告系列 / ad_group=广告组），经路径参数 {group} 区分，
 * 两组共用同一张表（apple_asa_ad_name_template），类型统一来自
 * types/adNameTemplate.types.ts（跨域共享，与后端 Pydantic 对齐）。
 */

import { request } from "../apiClient";
import type {
  AdNameTemplateRecord,
  SaveAdNameTemplateBody,
} from "../../types/adNameTemplate.types";

/** 模板组标识：campaign=广告系列 / ad_group=广告组（与后端 TemplateGroupStr 枚举值一致） */
export type AdNameTemplateGroup = "campaign" | "ad_group";

export async function getLatestTemplate(
  group: AdNameTemplateGroup,
): Promise<AdNameTemplateRecord | null> {
  const data = await request<AdNameTemplateRecord | null>(
    `/api/v1/apple-asa/ad-name-template/${group}`,
  );
  return data ?? null;
}

export async function saveTemplate(
  group: AdNameTemplateGroup,
  body: SaveAdNameTemplateBody,
): Promise<AdNameTemplateRecord> {
  return request<AdNameTemplateRecord>(
    `/api/v1/apple-asa/ad-name-template/${group}`,
    {
      method: "PUT",
      body,
    },
  );
}

export async function deleteTemplate(
  group: AdNameTemplateGroup,
): Promise<void> {
  await request<unknown>(`/api/v1/apple-asa/ad-name-template/${group}`, {
    method: "DELETE",
  });
}
